import { useMemo, useState } from "react";
import { api } from "@/lib/api";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { DOC_TIPOS, docsObrigatoriosFaltando } from "./constants";
import { DocumentoRow } from "./DocumentoRow";

function ResumoObrigatorios({ faltando, inscricaoId }) {
  if (faltando > 0) {
    return (
      <div className="flex items-center gap-2 text-xs bg-orange-50 border border-orange-200 rounded px-3 py-2 text-orange-800" data-testid={`docs-pendentes-${inscricaoId}`}>
        <AlertTriangle className="w-4 h-4 shrink-0" />
        <span><strong>{faltando}</strong> documento(s) obrigatório(s) ainda pendente(s).</span>
      </div>
    );
  }
  return (
    <div className="flex items-center gap-2 text-xs bg-green-50 border border-green-200 rounded px-3 py-2 text-green-800" data-testid={`docs-completos-${inscricaoId}`}>
      <CheckCircle2 className="w-4 h-4 shrink-0" />
      <span>Todos os documentos obrigatórios enviados.</span>
    </div>
  );
}

export function DocumentosChecklist({ inscricao, onDocChange }) {
  const [uploading, setUploading] = useState({});
  const docsPorTipo = useMemo(() => {
    const map = {};
    (inscricao.documentos || []).forEach((d) => { map[d.tipo] = d; });
    return map;
  }, [inscricao.documentos]);

  const upload = async (tipo, file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("tipo", tipo);
    fd.append("file", file);
    setUploading((p) => ({ ...p, [tipo]: true }));
    try {
      const r = await api.post(`/inscricoes/${inscricao.id}/documentos`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(`Documento "${tipo}" enviado!`);
      onDocChange?.(inscricao.id, r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Falha no upload");
    } finally {
      setUploading((p) => ({ ...p, [tipo]: false }));
    }
  };

  return (
    <div className="space-y-3" data-testid={`cidadao-docs-${inscricao.id}`}>
      <ResumoObrigatorios faltando={docsObrigatoriosFaltando(inscricao.documentos).length} inscricaoId={inscricao.id} />
      <div className="divide-y border rounded-lg overflow-hidden">
        {DOC_TIPOS.map((t) => (
          <DocumentoRow
            key={t.key}
            tipo={t}
            inscricaoId={inscricao.id}
            existing={docsPorTipo[t.key]}
            uploading={Boolean(uploading[t.key])}
            onUpload={upload}
          />
        ))}
      </div>
    </div>
  );
}
